import { useEffect, useState } from 'react';

import { Maybe } from '~/types';

const hash = async (string: string) => {
  const utf8 = new TextEncoder().encode(string);
  const hashBuffer = await crypto.subtle.digest('SHA-256', utf8);
  const hashArray = Array.from(new Uint8Array(hashBuffer));
  const hashHex = hashArray.map((bytes) => bytes.toString(16).padStart(2, '0')).join('');
  return hashHex;
};

const useHash = (content: Maybe<string>) => {
  const [hashed, setHashed] = useState<string>();

  useEffect(() => {
    const canIncludeGlossaryTerm = content && typeof content === 'string';

    if (!canIncludeGlossaryTerm) {
      return;
    }

    hash(content).then(setHashed);
  }, [content]);

  return hashed;
};

export default useHash;
